module.exports = __webpack_public_path__ + "static/media/Barmag 6c3.5b2fcc8b.jpg";